import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BeanLogs } from 'src/bean/BeanLogs';
import { environment } from 'src/environments/environment';

@Injectable()
export class LogsService {

  constructor(
    private http: HttpClient
  ) { }

  public getHeaders(){

    const tokenString = localStorage.getItem('access_token');

    const headers = {
      'Authorization' : 'Bearer ' + tokenString,
      'Content-Type': 'application/json'
    };

    return headers;
  }

  public listarStatusMonitory(idMonitory:string):Observable<any> {

    const headers = this.getHeaders();

    return this.http.get(`${environment.urlBackend}${environment.getAllStatusMonitoryByIdMonitory}${idMonitory}`, {headers});
  }

  addLogs(beanLogs: BeanLogs):Promise<any>{
    return this.gravarLogs(beanLogs).toPromise().then((resposta:any) => resposta);
  }

  public gravarLogs(beanLogs: BeanLogs):Observable<any>{

    const headers = this.getHeaders();

    let json = JSON.stringify(beanLogs);

    return this.http.post(`${environment.urlBackend}${environment.createLog}`,json, {headers});
  }

  deleteStatusMonitory(stmaIdCdStatusMonitoria: string):Promise<any>{
    return this.excluirStatusMonitory(stmaIdCdStatusMonitoria).toPromise();
  }

public excluirStatusMonitory(stmaIdCdStatusMonitoria: string):Observable<any> {

  const headers = this.getHeaders();


  return this.http.delete(`${environment.urlBackend}${environment.deleteStatusMonitoryById}${stmaIdCdStatusMonitoria}`, {headers});
}
}
